function templateReplace(template, vars) {
    return template.replace(/\{\{(\w+)\}\}/g, (_, key)=>vars[key] ?? "");
}
export { templateReplace };
